"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["dataMetrics", "disabled", "fullWidth", "onClick", "width"],
  _excluded2 = ["classes"],
  _excluded3 = ["classes"],
  _excluded4 = ["classes"],
  _excluded5 = ["InputLabelProps", "InputProps", "FormHelperTextProps", "style"],
  _excluded6 = ["error", "focused", "root"],
  _excluded7 = ["disabled", "error", "focused", "input", "root", "underline"],
  _excluded8 = ["error", "root"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    disabled: {},
    error: {},
    focused: {},
    formHelperTextError: {},
    formHelperTextRoot: _objectSpread({}, theme.typography.caption, {
      '&$disabled': {
        color: theme.palette.opacity.black[60]
      },
      '&$formHelperTextError': {
        color: theme.palette.accent.redMain
      },
      color: theme.palette.opacity.black[60],
      marginTop: theme.spacing(0.5),
      width: function width(props) {
        return props.width;
      }
    }),
    formLabelError: {},
    formLabelFocused: {},
    formLabelReadOnly: {},
    formTextLabelRoot: _objectSpread({}, theme.typography.overline, {
      '&$formLabelError': {
        color: theme.palette.accent.redMain
      },
      '&$formLabelFocused:not($formLabelError):not(&$formLabelReadOnly)': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'main']
      },
      '&$formLabelReadOnly': {
        color: theme.palette.opacity.black[60]
      },
      color: theme.palette.opacity.black[60],
      textTransform: 'none'
    }),
    input: {
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'not-allowed'
      },
      '&:read-only': {
        cursor: 'default'
      },
      color: theme.palette.text.primary
    },
    inputRoot: _objectSpread({}, theme.typography.body1, {
      '&$disabled': {
        background: theme.palette.opacity.black[8],
        cursor: 'not-allowed'
      },
      '&$error$focused': {
        border: "2px solid ".concat(theme.palette.accent.redMain)
      },
      '&$error:not($focused)': {
        border: "2px solid ".concat(theme.palette.accent.redMain)
      },
      '&$focused': {
        background: theme.palette.white,
        border: "2px solid ".concat(theme.palette.primary[800])
      },
      '&$readonly': {
        cursor: 'default'
      },
      '&:hover:not($disabled):not($focused):not($error):not($readonly)': {
        borderColor: theme.palette.opacity.black[87]
      },
      '&:not($focused)': {
        borderColor: theme.palette.opacity.black[24]
      },
      border: 'solid thin',
      borderRadius: theme.shape.borderRadius / 2,
      boxSizing: 'border-box',
      minHeight: '36px',
      minWidth: '120px',
      padding: theme.spacing(0, 1, 0, 2),
      width: function width(props) {
        return props.width;
      }
    }),
    multilineAdorment: {
      margin: theme.spacing(1, 0, 1, 0),
      resize: 'vertical'
    },
    readonly: {
      '&$focused': {
        background: theme.palette.opacity.black[4],
        border: "1px solid ".concat(theme.palette.opacity.black[24])
      },
      '&:hover': {
        background: theme.palette.opacity.black[4],
        border: "1px solid ".concat(theme.palette.opacity.black[24])
      },
      background: theme.palette.opacity.black[4],
      border: "1px solid ".concat(theme.palette.opacity.black[24])
    },
    root: {
      border: '1px solid #ced4da'
    },
    underline: {}
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_text_field'
  },
  fullWidth: false,
  required: false,
  select: false,
  variant: 'standard'
};

/**
 * Text fields allow users to enter text into a UI. They typically appear in forms and dialogs.
 * Text fields should:
 * - Stand out and indicate that users can input information.
 * - Have states that are clearly differentiated from one another.
 * - Have fields that make it easy to understand the requested information and to address any errors.
 */
var TextField = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var dataMetrics = _ref.dataMetrics,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    onClick = _ref.onClick,
    width = _ref.width,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    width: fullWidth || !width ? '100%' : width
  });
  var _rest$InputLabelProps = rest.InputLabelProps;
  _rest$InputLabelProps = _rest$InputLabelProps === void 0 ? {} : _rest$InputLabelProps;
  var _rest$InputLabelProps2 = _rest$InputLabelProps.classes,
    inputLabelClasses = _rest$InputLabelProps2 === void 0 ? {} : _rest$InputLabelProps2,
    restInputLabelProps = (0, _objectWithoutProperties2["default"])(_rest$InputLabelProps, _excluded2),
    _rest$InputProps = rest.InputProps;
  _rest$InputProps = _rest$InputProps === void 0 ? {} : _rest$InputProps;
  var _rest$InputProps$clas = _rest$InputProps.classes,
    inputClasses = _rest$InputProps$clas === void 0 ? {} : _rest$InputProps$clas,
    restInputProps = (0, _objectWithoutProperties2["default"])(_rest$InputProps, _excluded3),
    _rest$FormHelperTextP = rest.FormHelperTextProps;
  _rest$FormHelperTextP = _rest$FormHelperTextP === void 0 ? {} : _rest$FormHelperTextP;
  var _rest$FormHelperTextP2 = _rest$FormHelperTextP.classes,
    formHelperTextClasses = _rest$FormHelperTextP2 === void 0 ? {} : _rest$FormHelperTextP2,
    restFormHelperTextProps = (0, _objectWithoutProperties2["default"])(_rest$FormHelperTextP, _excluded4),
    style = rest.style,
    other = (0, _objectWithoutProperties2["default"])(rest, _excluded5);
  var isReadOnly = restInputProps !== undefined && restInputProps.readOnly === true;
  var inputLabelClassesError = inputLabelClasses.error,
    inputLabelClassesFocused = inputLabelClasses.focused,
    inputLabelClassesRoot = inputLabelClasses.root,
    inputLabelClassesRest = (0, _objectWithoutProperties2["default"])(inputLabelClasses, _excluded6);
  var inputClassesDisabled = inputClasses.disabled,
    inputClassesError = inputClasses.error,
    inputClassesFocused = inputClasses.focused,
    inputClassesInput = inputClasses.input,
    inputClassesRoot = inputClasses.root,
    inputClassesUnderline = inputClasses.underline,
    inputClassesRest = (0, _objectWithoutProperties2["default"])(inputClasses, _excluded7);
  var formHelperTextClassesError = formHelperTextClasses.error,
    formHelperTextClassesRoot = formHelperTextClasses.root,
    formHelperTextClassesRest = (0, _objectWithoutProperties2["default"])(formHelperTextClasses, _excluded8);
  var onClickHandler = disabled && onClick ? undefined : onClick;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.root,
    disabled: disabled,
    InputLabelProps: _objectSpread({
      classes: _objectSpread({
        error: (0, _classnames["default"])(classes.formLabelError, inputLabelClassesError),
        focused: (0, _classnames["default"])(classes.formLabelFocused, inputLabelClassesFocused, (0, _defineProperty2["default"])({}, classes.formLabelReadOnly, isReadOnly)),
        root: (0, _classnames["default"])(classes.formTextLabelRoot, inputLabelClassesRoot)
      }, inputLabelClassesRest),
      shrink: true /* stop from animating */
    }, restInputLabelProps),
    InputProps: _objectSpread({
      classes: _objectSpread({
        disabled: (0, _classnames["default"])(classes.disabled, inputClassesDisabled),
        error: (0, _classnames["default"])(classes.error, inputClassesError),
        focused: (0, _classnames["default"])(classes.focused, inputClassesFocused),
        input: (0, _classnames["default"])(classes.input, inputClassesInput, (0, _defineProperty2["default"])({}, classes.multilineAdorment, rest.multiline)),
        root: (0, _classnames["default"])(classes.inputRoot, inputClassesRoot, (0, _defineProperty2["default"])({}, classes.readonly, isReadOnly)),
        underline: (0, _classnames["default"])(classes.underline, inputClassesUnderline)
      }, inputClassesRest),
      disableUnderline: true
    }, restInputProps),
    FormHelperTextProps: _objectSpread({
      classes: _objectSpread({
        error: (0, _classnames["default"])(classes.formHelperTextError, formHelperTextClassesError),
        root: (0, _classnames["default"])(classes.formHelperTextRoot, formHelperTextClassesRoot)
      }, formHelperTextClassesRest)
    }, restFormHelperTextProps),
    onClick: onClickHandler,
    ref: ref,
    fullWidth: fullWidth
  }, other));
});
TextField.defaultProps = defaultProps;
TextField.displayName = 'TextField';
TextField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes["default"].string,
  /**
   * If `true` the input will be focused during the first mount.
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * @ignore
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/text-field/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * If `true` the input will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If `true` the label will be displayed in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * Properties applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: _propTypes["default"].object,
  /**
   * If `true` the input will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes["default"].node,
  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes["default"].string,
  /**
   * Properties applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: _propTypes["default"].object,
  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes["default"].object,
  /**
   * Attributes applied to the native `input` element.
   */
  inputProps: _propTypes["default"].object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /**
   * The label content.
   */
  label: _propTypes["default"].node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes["default"].oneOf(['none', 'dense', 'normal']),
  /**
   * If `true` a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes["default"].bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes["default"].string,
  /**
   * @ignore
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,
  /**
   * @ignore
   */
  onFocus: _propTypes["default"].func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * If `true` the label is displayed as required and the input will be required.
   */
  required: _propTypes["default"].bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes["default"].bool,
  /**
   * Properties applied to the [`Select`](/api/select/) element.
   */
  SelectProps: _propTypes["default"].object,
  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes["default"].string,
  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]))]),
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),
  /**
   * A fixed width of TextField in pixels, has lower priority than fullWidth. Ex: 400, 400px
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = TextField;
exports["default"] = _default;